export default {
  errors: null,
  iron_types: [],
  loading: false,
  count: 0,
  totalCount: 0
};
